import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import styles from './FixedPriceToggle.css'
import classNames from 'classnames'
import ToggleButton from '../ToggleButton/ToggleButton'

@CSSModules(styles, { allowMultiple: true })

export default class FixedPriceToggle extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    estimateLoading: PropTypes.bool,
    onChange: PropTypes.func
  }

  render () {
    const containerClasses = classNames('fixed-price-toggle', {
      loading: this.props.estimateLoading
    })    
    return (
      <div styleName={containerClasses}>
      	<h2>Fastpris</h2>
        <ToggleButton 
          checked={this.props.checked}
          name="fixed-price"
          onChange={this.props.onChange} 
        />  
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FixedPriceToggle/FixedPriceToggle.js